import { ReactNode } from 'react';

import { Color } from '@/core/interfaces/common';

import { StyledChip } from './Chip.styles';

export type ChipProps = {
  children: ReactNode;
  color?: Color;
}

export const Chip = ({
  children,
  color = Color.BLUE,
}: ChipProps) => (
  <StyledChip $color={color}>
    {children}
  </StyledChip>
);
